import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const ExcelIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 36 36" {...props}>
    <rect width="100%" height="100%" rx="4" fill="#0F7A3F" />
    <path
      d="M8.25 28.4239L15.2939 17.962L8.84694 7.53804H14.0602L17.5622 14.1576C17.8288 14.621 18.055 15.1045 18.2388 15.6033C18.4589 15.0944 18.7114 14.5989 18.9949 14.1196L22.9745 7.5H27.75L20.9449 17.962L27.75 28.5H22.6561L18.6765 21.1576C18.4646 20.8617 18.2909 20.5423 18.1592 20.2065C18.0269 20.5353 17.8672 20.8533 17.6816 21.1576L13.4633 28.5L8.25 28.4239Z"
      fill="white"
    />
  </Icon>
)
